import React from 'react'
import { useQuery } from '@apollo/client'
import { Container, Alert } from '@mui/material'
import { useSelector } from 'react-redux'
import { getIdFromV2Location } from 'services/content'
import {
  CONTENT_TYPE_PERSON,
  CONTENT_TYPE_SERIES,
  CONTENT_TYPE_TAG,
} from 'services/content/content-types'
import { selectLocation } from 'services/location/redux/selectors'
import Loader from 'gui/components/common/Loader'
import VideoDetailV2 from './video-detail-v2'
import SeriesDetailV2 from './series-detail-v2'
import PersonDetailV2 from './person-detail-v2'
import TagDetailV2 from './tag-detail-v2'
import { GET_CONTENT_TYPE } from './queries'

/**
 * Resolves content type for the current V2 detail URL and renders the appropriate
 * detail component (VideoDetailV2, SeriesDetailV2, PersonDetailV2, or TagDetailV2).
 * Used only for /v2/content/:id.
 */
function ContentDetailV2Router () {
  const location = useSelector(selectLocation)
  const id = getIdFromV2Location(location)

  const { loading, error, data } = useQuery(GET_CONTENT_TYPE, {
    variables: { id },
    skip: id === undefined || id === null,
  })

  if (loading) {
    return <Loader />
  }

  if (error) {
    return (
      <Container>
        <Alert severity="error" sx={{ mt: 3 }}>
          <div>
            <strong>Error loading content</strong>
          </div>
          <div>{error.message}</div>
        </Alert>
      </Container>
    )
  }

  const content = data?.contentList?.content?.[0]
  if (!content) {
    return (
      <Container>
        <Alert severity="warning" sx={{ mt: 3 }}>
          <div>
            <strong>Content not found</strong>
          </div>
          <div>No content found with ID: {id}</div>
        </Alert>
      </Container>
    )
  }

  const contentType = content.contentType?.toLowerCase()

  if (contentType === CONTENT_TYPE_SERIES) {
    return <SeriesDetailV2 id={id} />
  }
  if (contentType === CONTENT_TYPE_PERSON) {
    return <PersonDetailV2 id={id} />
  }
  if (contentType === CONTENT_TYPE_TAG) {
    return <TagDetailV2 id={id} />
  }
  return <VideoDetailV2 id={id} />
}

export default ContentDetailV2Router
